import { Users, UserCheck, Workflow, UserPlus } from 'lucide-react';

interface LeadStatsProps {
    totalLeads: number;
    activeLeads: number;
    leadsInFunnel: number;
    newToday: number;
    isUpdating?: boolean;
}

export default function LeadStats({
    totalLeads,
    activeLeads,
    leadsInFunnel,
    newToday,
    isUpdating,
}: LeadStatsProps) {
    const stats = [
        {
            label: 'Total de Leads',
            value: totalLeads.toLocaleString('pt-BR'),
            icon: Users,
            text: 'text-blue-600',
            lightBg: 'bg-blue-50',
            border: 'border-blue-100',
        },
        {
            label: 'Leads Ativos',
            value: activeLeads.toLocaleString('pt-BR'),
            icon: UserCheck,
            text: 'text-emerald-600',
            lightBg: 'bg-emerald-50',
            border: 'border-emerald-100',
        },
        {
            label: 'Em Funis',
            value: leadsInFunnel.toLocaleString('pt-BR'),
            icon: Workflow,
            text: 'text-cyan-600',
            lightBg: 'bg-cyan-50',
            border: 'border-cyan-100',
        },
        {
            label: 'Novos (24h)',
            value: newToday.toLocaleString('pt-BR'),
            icon: UserPlus,
            text: 'text-amber-600',
            lightBg: 'bg-amber-50',
            border: 'border-amber-100',
        },
    ];

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {stats.map((stat) => (
                <div
                    key={stat.label}
                    className={`relative overflow-hidden rounded-xl border ${stat.border} bg-white p-5 hover:shadow-lg transition-all duration-300 group`}
                >
                    <div className={`absolute top-0 right-0 w-32 h-32 ${stat.lightBg} rounded-full blur-3xl opacity-30 -mr-16 -mt-16 group-hover:opacity-50 transition-opacity`} />

                    <div className="relative z-10">
                        <div className="flex items-center justify-between mb-4">
                            <div className={`p-2.5 rounded-lg ${stat.lightBg}`}>
                                <stat.icon className={`h-5 w-5 ${stat.text}`} strokeWidth={1.5} />
                            </div>
                        </div>
                        <h3 className="text-sm font-medium text-gray-600 mb-1">{stat.label}</h3>
                        <p className={`text-2xl font-bold text-gray-900 transition-opacity duration-300 ${isUpdating ? 'opacity-40' : 'opacity-100'}`}>
                            {stat.value}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
}